import angular, { version } from 'angular';
import moment from 'moment';
import URLS from 'Helpers/urls';

(function() {
    'use strict';

    angular.module('app').component('applyModal3', {
        template: require('./apply-modal3.html'),
        controller: Ctrl,
        controllerAs: 'vm',
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }
    });

    Ctrl.$inject = [
        '$scope',
        '$cookies',
        '$timeout',
        '$state',
        'UploadService',
        'logger',
        'SweetAlert',
        'QueryService'
    ];

    function Ctrl($scope, $cookies, $timeout, $state, UploadService, logger, SweetAlert, QueryService) {
        var vm = this;
        vm.content = null;
        vm.close = close;

        // vm.page starts at 1
        vm.page = 1;
        
        setTimeout(() => {
            if(vm.resolve.Modal.page){
                vm.page = vm.resolve.Modal.page;
            }

        }, 100);
        // vm.page = 'apply'; //uncomment this later
        // vm.page = 'download';
        vm.quiz_page = 0;
        vm.titles = [
            'Part 1 of 6 Passage Reading',
            'Part 2 of 6 Essay Writing',
            'Part 3 of 6 Identifying errors (5 items)',
            'Part 4 of 6 Basic Information',
            'Part 5 of 6 Availability',
            'Part 6 of 6 Introduce yourself!',
        ];
        
        vm.account_fields = [
            { name: 'Email Address',   key: 'email' },
            { name: 'Username',        key: 'username' },
            { name: 'Password',        key: 'password', type: 'password' },
            { name: 'Retype Password', key: 'cpassword', type: 'password' },
        ];

        vm.data = { username: 'Noobmaster 69' };
        vm.data = {};

        navigator.getUserMedia = ( navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia);

        vm.days = ['Su', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
        vm.times = [6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23];


        if(!vm.data.quiz){
            vm.data.quiz = {};
        }

        if(!vm.data.tags){
            vm.data.tags = {};
        }
        if(!vm.data.availability){
            vm.data.availability = [];

            vm.days.forEach((day, x) => {
                vm.data.availability[x] = [];
                vm.times.forEach((time,y) => {
                    vm.data.availability[x][y] = { value: false, time: time, day:day };
                });
            });

        }

        // controls
        vm.clickback = () => {
            if(vm.page === 0) return;

            vm.page = vm.page - 1;
        }

        vm.clickableback = ()=> vm.page != 0;
        vm.clickablenext = ()=> vm.page !== vm.titles.length - 1;

        vm.clicknext = () => {
            if(vm.page === vm.titles.length - 1) return;
            
            vm.page = vm.page + 1;
        }
        function close(gotologin){
            vm.modalInstance.close();
            if(gotologin){
                window.location = '/#!/login?popup=0';
            }
        }

        
        vm.click_time = (_time)=>{
            console.log(vm.data.availability);
            let v = true;
            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    
                    if(time == _time){
                        if(vm.data.availability[x][y].value){
                            v = false;
                        }
                    }

                });
            });

            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    if(time == _time){
                        console.log(vm.data.availability[x][y], x, y ,vm.data);
                        vm.data.availability[x][y].value = !!v;
                    }
                });
            });

        }

        vm.click_day = (_day)=>{
            
            let v = true;
            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    if(day == _day){
                        if(vm.data.availability[x][y].value){
                            v = false;
                        }
                    }

                });
            });

            vm.days.forEach((day, x) => {
                vm.times.forEach((time, y) => {
                    
                    if(day == _day){
                        vm.data.availability[x][y].value = !!v;
                    }

                });
            });

        }

        get_quiz();
        function get_quiz(){
            var request = {
                method: 'GET',
                params: false,
                hasFile: false,
                route: { quiz: 'teacher2' }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const d = response.data.data.items;
                        d.forEach(_d => {
                            _d.choices = _d.choices.replace(/\t/g, '');
                            _d.choices = JSON.parse(_d.choices);
                        });

                        vm.quiz = d;

                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loaded_now = true;
                });

        }

        const __mins = 15;
        const __seconds = 60;
        vm.get_timer = ()=>{

            function pad(num) {
                return ("0"+num).slice(-2);
            }
            function hhmmss(secs) {
              var minutes = Math.floor(secs / 60);
              secs = secs%60;
              var hours = Math.floor(minutes/60)
              minutes = minutes%60;
              return `${pad(minutes)}:${pad(secs)}`;
              // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
            }

            const start = (vm.start.getTime() || 0);
            const end = (vm.end.getTime() || 0);

            return hhmmss(parseInt((__mins*__seconds*1000 + (start - end))/1000));
        };

        function update_timer(apply){
            vm.end = new Date();

            if(vm.quiz_submitted){
                return false;
            }

            if(__mins*__seconds*1000 + (vm.start.getTime() - vm.end.getTime()) < 0 ){
                vm.submit_quiz();
                vm.ran_out_of_time = true;
            }else{
                $timeout(()=>{update_timer(1)}, 1000);
            }
            if(apply){
                vm.end = new Date();
                $scope.$apply();
            }
        }

        vm.start_quiz = ()=>{
            vm.page++;
            vm.start = new Date();
            update_timer();
        }
        
        vm.submit_quiz = ()=>{
            const answers = vm.quiz.map(q => {return { id: q.id, chosen: q.answer }  });

            vm.loading = true;
            var request = {
                method: 'POST',
                body: {
                    answers
                },
                route: URLS.base + `/quiz/teacher`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data.answers;
                        vm.answers = data;
                        vm.page++;
                        vm.quiz_submitted = 1;

                        const correct_answers = data.filter(d => d.correct).length;
                        vm.correct_answers = correct_answers;

                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );

        };

        vm.register = ()=>{

            vm.loading = true;
            var request = {
                method: 'POST',
                body: {
                    email: vm.data.email,
                    username: vm.data.username,
                    password: vm.data.password
                },
                route: URLS.base + `/teacher/register`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data.answers;
                        // vm.page = 'download';
                        window.location = '/#!/login?popup=1';
                        close();
                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );

        };

        vm.download_app = (os) => {
            if(!os){
                download('https://s3.ap-northeast-2.amazonaws.com/media.daisy152.com/app/Dayoung App.exe');
            }

            if(os === 'linux'){
                download('https://s3.ap-northeast-2.amazonaws.com/media.daisy152.com/app/Dayoung App.AppImage');
            }
                
        }

        function download(url) {
            const a = document.createElement('a')
            a.href = url
            a.download = url.split('/').pop()
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        }
        
        // vm.start_quiz();
        // vm.page++;
        // vm.page++;
        // vm.page++;
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/apply3/apply-modal3.component.js